import axios, { AxiosRequestConfig } from 'axios'
import appconst from './appconst'
import Vue from 'vue'
// import util from './util'
import { router } from '@/router'
import app from './app'
import cookie from 'js-cookie'
// import { Message } from 'element-ui'
import { Dialog } from 'vant'

const ajax = axios.create({
	baseURL: appconst.remoteServiceBaseUrl,
	timeout: 600000
})
// 以表单形式提交数据
ajax.prototype.postWithFormData = async (url: string, data?: any, config?: AxiosRequestConfig)=> {
	let fd = new URLSearchParams(data)
	if(!config && !config!.headers)
		config!.headers = {'Content-Type':'application/x-www-form-urlencoded'}
	return await ajax.post(url, fd, config)
}
ajax.interceptors.request.use((config) => {
	let access_token = cookie.get('access_token')
	if (!!access_token) {
		config.headers.common.Authorization = 'Bearer ' + access_token
	}
	config.headers.common['accept-language'] = 'zh-Hans'
	// let culture = cookie.get('.AspNetCore.Culture')
	// if (!culture) {
	// 	cookie.set('.AspNetCore.Culture', 'c=zh-Hans|uic=zh-Hans')
	// 	cookie.set('Abp.Localization.CultureName', 'zh-Hans')
	// }
	// 解决ie浏览器默认缓存机制
	config.headers['Cache-Control'] = 'no-cache;max-age=0'
	config.headers['Pragma'] = 'no-cache'
	return config
}, (error) => {
	return Promise.reject(error)
})
const vm = new Vue({})
ajax.interceptors.response.use((respon) => {
	if (respon.data.code === 1) {
		Dialog.alert({ title: '提示', message: respon.data.message })
	}
	return respon
}, (error) => {
	if (error.response && error.response.status === 401) {
		if (router.currentRoute.name !== 'login') {
			// app.logout()
			// vm.$router.push({path: '/login', query: { redirect: router.currentRoute.path }})
			Dialog.alert({ title: '请求需要授权', message: '请登录' })
		}
	} else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
		// vm.$msgbox({ title: error.response.data.error.message, message: error.response.data.error.details, type: 'error' })
		Dialog.alert({title: error.response.data.error.message, message: error.response.data.error.details})
	} else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
		// Message.error({ message: error.response.data.error.message})
		Dialog.alert({ title: '操作失败', message: error.response.data.error.message })
	} else if (error.response && error.response.status === 403) {
		// 已登录用户访问未授予权限的接口时返回这个403 status code
		// console.log('rep', error.response)
		let url = error.response.config.url as string
		Dialog.alert({ title: '您无权访问该请求', message: url})
	} else if(error.response && error.response.data.error) {
		let title = error.response.data.error
		let content = error.response.data.error_description
		// vm.$msgbox({ title, message: content, type: 'error' })
		Dialog.alert({ title, message: content})
 	}  else if (!error.response) {
		Dialog.alert({ title: '未知错误', message: '无法与服务器建立连接' })
	}
	return Promise.reject(error)
})
export default ajax
